export class Issue{
    title: string;
    description: string;
    discoveryDate: Date;
    occurredDate: Date;
}